import { SR_API_ACTION_LANDLORD_UPDATE } from 'api/actionTypes';

export default async function updateLandlord({ state, apiClient }, { landlordId, updates }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_LANDLORD_UPDATE,
    state: state,
    payload: {
      landlordId,
      updates,
    },
    onSuccess(landlord) {
      const landlordIdPath = ['landlords', 'byId', landlordId];
      if (state.get(landlordIdPath)) {
        state.set(landlordIdPath, landlord);
      }
    },
  });
}
